import {FC} from 'react'
import {useIntl} from 'react-intl'

type Props = {
  personalData: boolean
}

const Bitrix24UsersInServiceHeader: FC<Props> = ({personalData}) => {
  const intl = useIntl()

  return (
    <thead>
      <tr className='text-muted fs-9 text-center'>
        <th role='columnheader' className='min-w-70px text-end'>
          {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.USERS.ACTIVE'})}
        </th>
        <th role='columnheader' className='min-w-100px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.LINES.HEADER.USERID'})}
        </th>
        {personalData && (
          <th role='columnheader' className='min-w-150px px-0'>
            {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.USERS.NAME'})}
          </th>
        )}
        <th role='columnheader' className='min-w-150px px-0 required'>
          {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.USERS.NUMBER'})}
        </th>
        {personalData && (
          <th role='columnheader' className='min-w-150px px-0 required'>
            {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.USERS.MOBILE'})}
          </th>
        )}
        <th role='columnheader' className='min-w-100px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.LINES.HEADER.SMARTCALL'})}
        </th>
        <th role='columnheader' className='min-w-100px px-0 required'>
          {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.LINES.MANAGER.TIME'})}
        </th>
        <th role='columnheader' className='min-w-70px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.LINES.HEADER.TOCHAT'})}
        </th>
        <th role='columnheader' className='min-w-70px px-0 required'>
          {intl.formatMessage({id: 'APPS.SETTINGS.USERS.AA'})}
        </th>
        <th role='columnheader' className='min-w-70px px-0 required'>
          {intl.formatMessage({id: 'APPS.SETTINGS.USERS.MR'})}
        </th>
        <th role='columnheader' className='min-w-100px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.LINES.HEADER.EDIT'})}
        </th>
      </tr>
    </thead>
  )
}

export {Bitrix24UsersInServiceHeader}
